import { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const SpamProtection = ({ onVerify }) => {
  const [challenge, setChallenge] = useState({ a: 0, b: 0 });
  const [answer, setAnswer] = useState('');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    // Generate new challenge on mount
    setChallenge({
      a: Math.floor(Math.random() * 10) + 1,
      b: Math.floor(Math.random() * 10) + 1
    });
  }, []);

  const handleChange = (e) => {
    const val = e.target.value;
    setAnswer(val);
    setTouched(true);
    
    // Check answer
    const num = parseInt(val);
    if (!isNaN(num) && num === challenge.a + challenge.b) {
      onVerify(true);
    } else {
      onVerify(false);
    }
  };

  return (
    <div className="space-y-2 p-4 bg-gray-50 rounded-lg border border-gray-200">
      <Label htmlFor="math-challenge" className="text-gray-700 font-medium">
        Security Check: What is {challenge.a} + {challenge.b}?
      </Label>
      <Input
        id="math-challenge"
        type="number"
        value={answer}
        onChange={handleChange}
        placeholder="?"
        className="w-24"
        required
      />
      {touched && parseInt(answer) !== challenge.a + challenge.b && (
        <p className="text-xs text-red-500">Incorrect answer</p>
      )}
      
      {/* Honeypot field - hidden from users but visible to bots */}
      <div className="opacity-0 absolute -z-10 h-0 w-0 overflow-hidden">
        <label htmlFor="website_url">Website</label>
        <input 
          type="text" 
          id="website_url" 
          name="website_url" 
          tabIndex="-1" 
          autoComplete="off"
        />
      </div>
    </div>
  );
};

export default SpamProtection;
